<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window invite-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper dialog-content">
                <div class="dialog-body">
                    <div class="dialog-title t-invite"></div>
                    <div class="invite-view">
                        <div class="share-text msg-view">
                            <div class="text-content">
                                {{ shareTxt }}
                            </div>
                        </div>

                        <div class="u-btn copy" @click="copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt"></div>
                        
                        
                        <div class="reward-intro">
                            <div class="slogen-invite"></div>
                            <div class="reward-list flex-center-center">

                                <div class="rb">
                                    <div class="amt">X1</div>
                                </div>
                                
                                <div class="reward-item" v-for="(r,k) in reward_list" :key="k">
                                    <div class="icon-wrapper">
                                        <div class="reward-pic" v-tips="r.giftId"><game-item :locked="true" :id="r.giftId" :num="r.sendNum"></game-item></div>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>

                </div>

            </div>         
        </div>
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试', 
            error : false,
            reward_list : [
                {"giftId":"AQ33","giftName":"神之队员打造书页","sendNum":"5"},
                {"giftId":"QA22","giftName":"高级防具珍材包","sendNum":"30"}
            ],
            shareTxt : '',                  
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },    
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },
}
</script>

<style lang="scss" scoped>
.invite-modal{
    width: 700px;
    height: 519px;
    background-image: url(~@/assets/images/modal/bg-modal-invite.png);    
}

.dialog-content{
    // padding: 29px 39px;
}

.t-invite{
    width: 526px;
    height: 49px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/modal/title-invite.png);      
}

.invite-view{
    padding: 0 40px;
}

.text-content{
    display: flex;
    align-items: center;
    height: 130px;
    font-size: 22px;
    color: #f8e1dc;
    line-height: 1.8;
    word-break: break-all;

    p{
        margin: 0;
    }
}

.notice{
    margin-top: 20px;
    font-size: 18px;
    color: #ee6044;
    text-align: center;
}

.info{
    font-size: 20px;
    text-align: center;
    margin-bottom: 18px;
}

.u-btn.copy{
    width: 254px;
    height: 83px;
    margin: 15px auto 15px;
    background-image: url(~@/assets/images/modal/btn-copy.png);
}

.slogen-invite{
    width: 551px;
    height: 31px;
    margin: 5px auto 0;
    background-image: url(~@/assets/images/modal/slogen-modal-invite.png);    
}

.reward-intro{
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
}

.reward-list{
    margin-top: 14px;
}

.reward-item{
    margin: 0 20px;
}

.rb{
    position: relative;
    width: 80px;
    height: 82px;
    margin: 0 20px;
    background-image: url(~@/assets/images/modal/icon-rb_sm.png);

    .status{
        position: absolute;
        top: 55px;
        left: 50%;
        transform: translateX(-50%);        
    }
}

.amt{
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 45px;
    height: 27px;
    line-height: 27px;
    background-image: url(~@/assets/images/modal/bg-cnt.png);
    font-size: 25px;
    color: #ffcc83;
    font-family: "HYJinKaiJ";
    font-weight: 400;
    text-align: center;
}

.icon-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 82px;
    height: 82px;
    background-image: url(~@/assets/images/modal/bg-item_d.png);

    .reward-pic{
        width: 69px;
        height: 69px;
    }
}
</style>